<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">会议服务</span></p>'

      +'<table style="margin-left : 35px; margin-top : 30px; align-content: center; border: solid 1px lightgrey; font-size: 16px; text-align: center;  ">'
      +'<tr style="background-color: rgb(12, 92, 200); color: white; vertical-align: center">'
      +'<th style="border: solid 1px lightgrey;width: 250px">会议地点</th><th style="border: solid 1px lightgrey;width: 250px">可用设备</th><th style="border: solid 1px lightgrey;width: 250px">人数</th><th style="border: solid 1px lightgrey;width: 400px">会议室图片</th>'
      +'</tr>'

      +'<tr style="background-color: lightsteelblue; align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">C307A<br>C507A</td><td style="border: solid 1px lightgrey; vertical-align: middle">无线投影<br>无线投屏*1</td><td style="border: solid 1px lightgrey; vertical-align: middle">16 - 20人</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys1.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">C307B<br>C407B<br>C507B</td><td style="border: solid 1px lightgrey; vertical-align: middle">无线投影<br>无线投屏*1</td><td style="border: solid 1px lightgrey; vertical-align: middle">24 - 30人</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys2.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="background-color: lightsteelblue; align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">C407A</td><td style="border: solid 1px lightgrey; vertical-align: middle">投影<br>视讯<br>话筒*1<br>高清线*1<br>无线投屏*1</td><td style="border: solid 1px lightgrey; vertical-align: middle">16 - 20人</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys3.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">C100</td><td style="border: solid 1px lightgrey; vertical-align: middle">投影<br>无线投屏*2<br>话筒*4<br>鹅颈*8</td><td style="border: solid 1px lightgrey; vertical-align: middle">50 - 80人</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys4.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="background-color: lightsteelblue; align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">S120</td><td style="border: solid 1px lightgrey; vertical-align: middle"></td><td style="border: solid 1px lightgrey; vertical-align: middle">10人</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys5.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">S118</td><td style="border: solid 1px lightgrey; vertical-align: middle">移动投影（电视机)</td><td style="border: solid 1px lightgrey; vertical-align: middle">16 - 20人</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys6.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="background-color: lightsteelblue; align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">S119</td><td style="border: solid 1px lightgrey; vertical-align: middle">无线投影<br>无线投屏*1<br>话筒*1<br>小蜜蜂*1</td><td style="border: solid 1px lightgrey; vertical-align: middle">40 - 60人</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys7.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">C5</td><td style="border: solid 1px lightgrey; vertical-align: middle"></td><td style="border: solid 1px lightgrey; vertical-align: middle">60人</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys8.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="background-color: lightsteelblue; align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">一楼圆厅<br>（含小天井）</td><td style="border: solid 1px lightgrey; vertical-align: middle"></td><td style="border: solid 1px lightgrey; vertical-align: middle">最多300人或30个展位</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys10.png" alt="" width="398" ></td>'
      +'</tr>'

      +'<tr style="align: center; height: 200px;">'
      +'<td style="border: solid 1px lightgrey; vertical-align: middle">一楼大天井</td><td style="border: solid 1px lightgrey; vertical-align: middle">无线投屏*1<br>话筒*2<br>IPAD*1</td><td style="border: solid 1px lightgrey; vertical-align: middle">1000平米</td><td style="border: solid 1px lightgrey; vertical-align: middle"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/hys9.png" alt="" width="398" ></td>'
      +'</tr>'

      +'</table>'

      + '<p style="margin-top : 30px; margin-bottom : 0px"><span style="margin-left: 85px; font-size: 16px;">会议预约：</span></p>'
      + '<p style="margin-bottom : 0px"><span style="margin-left: 85px; font-size: 16px;">● 用户可以通过电话或邮件预约会议室。</span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 85px; font-size: 16px;">● 提交会议结算表（<a href="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/20200616转化医学大楼会议室结算表（试行）.docx">20200616转化医学大楼会议室结算表（试行</a>）.docx）预约。</span></p>'

      + '<p style="margin-bottom : 0px"><span style="margin-left: 85px; font-size: 16px;">电话：021-54320796</span></p>'
      + '<p style="margin-bottom : 20px"><span style="margin-left: 85px; font-size: 16px;">邮箱：nitm@sjtu.edu.cn</span></p>'

      + '<p style="margin-bottom : 20px"><span style="margin-left: 85px; font-size: 16px; color: red; font-weight: bold">*同时预约会议室，以先上交会议结算表的为准！</span></p>'

      + '<p>&nbsp;</p>'
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>

<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  margin-top: 0px;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service12/index.vue